import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getCompanyGigsApi} from "../../API/API";

function* getCompanyGigsSaga(action) {

    try {
        // const {limit, skip, status,search} = action.payload;
        const response = yield call(() => getCompanyGigsApi());
        yield put({ type: types.GET_COMPANY_GIGS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.GET_COMPANY_GIGS_FAILURE, error });
    }
}

export function* watchGetCompanyGigsSaga() {
    yield takeEvery(types.GET_COMPANY_GIGS_INIT, getCompanyGigsSaga);
} 